import * as doctorTypes from './types'
import * as doctorActions from './actions'
import doctorReducer from './reducer'

export {doctorActions, doctorTypes}

export default doctorReducer
